import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router';

import WelcomePanel from '../../../components/WelcomePanel';
import { ResetPasswordForm } from '../../../components/forms';
import { resetPassword } from '../../../service/auth';
import { Container } from '../SignIn/SignIn';
import Logo from '../../../assets/imgs/logo.png';

const ResetPassword = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const [isSending, setIsSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = async (data) => {
    const { password, confirmPassword } = data;
    console.log('[data]', token, data);
    setError('');
    setSuccess(false);
    setIsSending(true);

    try {
      if (password !== confirmPassword) {
        setError("Password doesn't match.");
        return;
      }

      await resetPassword({ password: data.password, token });
      setSuccess(true);
    } catch (err) {
      setError('Something went wrong, please try again.');
    } finally {
      setIsSending(false);
    }
  };

  useEffect(() => {
    let to;
    if (success) {
      to = setTimeout(() => setTimeout(false), 3000);
    }

    return () => to && clearTimeout(to);
  }, [success]);

  return (
    <div className="w-screen h-screen bg-white flex justify-center flex-col">
      <div className="hidden sm:block flex items-center justify-center w-full bg-primary px-12 py-9">
        <img src={Logo} alt="logo_img" />
      </div>
      <Container className="w-full m-auto flex bg-white shadow-xl sm:shadow-none">
        <div className="panel w-1/2 sm:hidden px-16 pt-24 pb-12 bg-primary">
          <WelcomePanel />
        </div>
        <div className="form-panel w-1/2 sm:w-full px-12 pt-24 pb-12">
          <div className="m-auto ">
            <ResetPasswordForm
              success={success}
              error={error}
              busy={isSending}
              onSubmit={handleSubmit}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ResetPassword;
